(function() { module.exports = window["Bernie_l10nBundle_ca_ES"]; }());